
var __toastMarkup = `
<div class="swym-notifications-container swym-showing swymTopLeft" ju_orig_top="20" style="top: 60px;" >
<div class="swym-notification-wishlist swym-clickable" style="cursor: pointer;" id="swym-toast">
<div class="swym-product-tile" style="    background: #fff;
    color: #000;
    padding: 5px;
    display: flex;
    align-items: center;
    position: relative;">
<button class="swym-close-btn swym-is-button" id="close-swym-toast"
style="
    position: absolute;
    top: 11px;
    right: 10px;
    cursor: pointer;
    width: auto;
    z-index: auto;
    display: inline-block;
    background: 0;
    border: 0;
    bottom: auto;
    box-shadow: none;
    clear: none;
    font-family: inherit;
    font-size: medium;
    font-style: normal;
    font-variant: normal;
    font-weight: normal;
    height: auto;
    left: auto;
    letter-spacing: normal;
    line-height: normal;
    margin: 0;
    max-height: none;
    max-width: none;
    min-height: 0;
    min-width: 0;
    opacity: 1;
    padding: 0;
    text-align: inherit;
    text-decoration: none;
    text-transform: none;
    transform: none;
    visibility: visible;
"
>
<span class="swym-icon">
</span></button>
<img class="swym-image" style="
        width: 50px;
    flex-shrink: 0;"
 src="{{iu}}"
 alt=""><div class="swym-details-container"  id="openWl" style="display: flex;
    flex-direction: column;">
 <div class="swym-details" role="alert" style="
    padding: 15px 25px 10px 15px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: .1em;
    color: #434655;
    word-break: break-word;
">
 <span class="swym-emphasis" style="font-weight: bold;">$product_name</span> has been added to 
 <span class="swym-emphasis" style="font-weight: bold;">1 list</span> successfully.</div></div></div></div></div>`;
function swymCallbackFn(swat) {
  //   Toast Options - Set Autohide to true, to hide after delay.
  var options = {
    autohide: true,
    delay: 3000,
    animation: true
  };

  function showCustomNotification(event) {
    window._swat.getProductDetails({
                empi: event.detail.d.empi,
                du: event.detail.d.du
    }, (productInfo) => {
       var parentContainer = document.querySelector("#swym-custom-notify-container");
    var product = event.detail.d;
    if (parentContainer && bootstrap.Toast) {
      parentContainer.innerHTML = ""; // Reset old toasts;
      product = SwymUtils.formatProductPrice(product);
      product.variantInfo = getVariantInfo(product.variants);
      __toastMarkup =  __toastMarkup.replace('$product_name', productInfo.title)
      let toastDetails = SwymUtils.renderTemplateString(__toastMarkup, product);
      parentContainer.innerHTML = toastDetails;
      let toastElement = document.querySelector("#swym-toast");
      let toast = new bootstrap.Toast(toastElement, options);
      document.querySelector('#close-swym-toast').onclick = function() {
          toast.hide();
         parentContainer.innerHTML = ""; // Reset old toasts;
      }
      toast.show();
      bindEvent();
		
      function bindEvent() {
        document.getElementById('openWl').onclick = function() {
          swat.ui.open();
          parentContainer.innerHTML = ""; // Reset old toasts;
        }
      }
    }
    
    });


    function getVariantInfo(variants) {
      try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(variants[0]) : []),
            variantinfo;
        if (variantKeys.length) {
          variantinfo = variantKeys[0];
        }
        return (variantinfo == "Default Title") ? "" : variantinfo;
      } catch (err) {
        return variants;
      }
    }
  }
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function(event) {
    //Show custom Notifications on event;	
    showCustomNotification(event);
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);